/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentHistorySortCriteria {
    getFixupPrototypeFunction() { return ComplianceAssessmentHistorySortCriteria.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentHistorySortCriteria>): ComplianceAssessmentHistorySortCriteria {
        let obj = Object.assign(new ComplianceAssessmentHistorySortCriteria(), model);
        ComplianceAssessmentHistorySortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentHistorySortCriteria>): ComplianceAssessmentHistorySortCriteria {
        if (!model) return null;
        return ComplianceAssessmentHistorySortCriteria.newInstance(<ComplianceAssessmentHistorySortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentHistorySortCriteria) {
        if (!obj) return;

        models.ComplianceAssessmentHistorySortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentHistorySortCriteria): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentHistorySortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.ComplianceAssessmentHistorySortColumn;

    ascending: boolean;

}
